/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_TabInputs */



/**
* | output |
* | --- |
* | "Watermark" |
*
* @param {Options_Watermark_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_tab = /** @type {((inputs?: Options_Watermark_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filigrane")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wasserzeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filigrana")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Водяной знак")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marca de agua")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("水印")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ウォーターマーク")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉटरमार्क")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marca de água")
	return /** @type {LocalizedString} */ ("Watermark")
});